import { Button, Space, notification, type NotificationArgsProps } from 'antd';

export type NotificationPopUpProps = {
  type: NonNullable<NotificationArgsProps['type']>;
  placement?: NotificationArgsProps['placement'];
  message: string;
  description?: string;
  duration?: number | null;
  showConfirmBtn?: boolean;
  key?: string;
  confirmBtnLabel?: string;
  onConfirm?: () => Promise<void> | void;
  onClose?: () => void;
};

const openNotification = ({
  type,
  placement,
  message,
  description,
  duration,
  showConfirmBtn,
  key,
  confirmBtnLabel,
  onConfirm,
  onClose,
}: NotificationPopUpProps) => {
  const handleOnClick = () => {
    if (onConfirm) {
      onConfirm();
    }
    notification.destroy(key);
  };
  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
    notification.destroy(key);
  };
  const actions = showConfirmBtn ? (
    <Space>
      <Button
        type="default"
        onClick={handleOnClose}
        data-cy={`cancel-ntf-btn-${key}`}
        className="btn-secondary"
        danger
      >
        Cerrar
      </Button>
      <Button
        type="primary"
        data-cy={`confirm-ntf-btn-${key}`}
        onClick={handleOnClick}
      >
        {confirmBtnLabel ?? 'Confirmar'}
      </Button>
    </Space>
  ) : (
    <></>
  );
  notification[type]({
    key: key ? key : `notification-${Date.now()}`,
    title: message,
    description,
    placement: placement ? placement : 'topRight',
    // In seconds, default: 4.5. AntD 6 uses false for persistent notices.
    duration: duration === null ? false : duration,
    actions,
    className: 'app-notification',
    classNames: {
      title: 'app-notification-title',
      description: 'app-notification-description',
    },
    onClose,
  });
};

export default openNotification;
